<div class="main">
  <div class="content">
    <div class="icon-and-text">
      <div
        class="avatar"
        style="background: url('images/default-agent.png')"
      ></div>
      <div class="text">
        <div class="heading">
          <div class="agent-text">It's me, Johnny</div>
          <div class="header-text">
            We need to prioritize your results before moving on.
          </div>
        </div>
        <div class="message-text">
          Don't worry, you can revisit your choice later.
        </div>
      </div>
    </div>
    <div class="prioritize">
      <div class="prioritize-header">
        <div class="prioritize-text">Select to prioritize</div>
        <!-- <rr-btn type="Secondary" tone="brand" size="Small" iconStart="ai"
          >Support me</rr-btn
        > -->
      </div>
      <div
        class="prioritize-item"
        *ngFor="let persona of data"
        (click)="selectPersona(persona)"
        [ngClass]="{ 'selected-item': selectedPersona == persona }"
      >
        <div class="radio">
          <div *ngIf="selectedPersona !== persona">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                fill="white"
              />
              <path
                d="M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z"
                stroke="#000D4D"
                stroke-opacity="0.45"
              />
            </svg>
          </div>
          <div *ngIf="selectedPersona == persona">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                fill="#4C64D9"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16 22C19.3137 22 22 19.3137 22 16C22 12.6863 19.3137 10 16 10C12.6863 10 10 12.6863 10 16C10 19.3137 12.6863 22 16 22Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div
          class="image"
          [style]="
            persona.image
              ? persona.image
              : 'background-image: url(images/default-persona.png)'
          "
        ></div>
        <div class="info">
          <div
            class="info-heading"
            [ngClass]="{ 'selected-header': selectedPersona == persona }"
          >
            {{ persona.name }}
          </div>
          <div class="subheadline">{{ persona.demographics.occupation }}</div>
          <div class="info-subtitle">{{ persona.short_summary }}</div>
        </div>
        <!-- <div>
          <rr-icon name="eye"></rr-icon>
        </div> -->
      </div>
    </div>
    <div class="button-group">
      <rr-btn
        type="Link"
        class="underline"
        iconStart="arrow-left"
        (btnclick)="back()"
        >Back</rr-btn
      >
      <rr-btn
        type="Primary"
        tone="brand"
        [disabled]="!selectedPersona"
        (click)="saveSelectedPersona()"
        >Go ahead</rr-btn
      >
    </div>
  </div>
</div>
